var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{ref:"p",staticClass:"p-editable",class:{
    'editable--empty': _vm.isEmpty,
    'editable--bordered': _vm.bordered,
    'p-editable--focused': _vm.focused
  },attrs:{"contenteditable":!_vm.disabled,"data-placeholder":_vm.placeholder},on:{"input":_vm.onInput,"keypress":[_vm.onKeypress,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onKeypressEnter.apply(null, arguments)}],"focus":function($event){_vm.focused = true},"blur":_vm.handleBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }